
import LoadSimple from "../../LoadSimple";
import Modal from 'react-modal';
import ModalDeleteUSer from "./ModalDeleteUser";
import { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '20%',
    padding: '20px'
  },
};
const PortafolioList = ({
  pageActual,
  limitList, startLimit,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  cisSelected,
  setCisSelected,
  languaje, mode
}) => {
  const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({})
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setDeleteUserModalOpen(false);
  }
  const handledeleteUserClick = (data) => {

    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  const handleEditUserClick = (data) => {

    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  useEffect(() => {
    buscar_cis();
  }, []);
  const buscar_cis = () => {
    // setLoadingCis(true)
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/exception_agencies",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setDataUsers(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };
  const delteException = (elemento) => {

  }
  return (
    <>
      <div className="cont-row-user-list">
        {dataUsers.loading ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio" + mode}
                key={indice}
              >
                <div className="field-body-table-mantenimiento field-medium" style={{ fontWeight: '500', color: 'var(--txt-color)', opacity: 0.8 }}>
                  #{elemento.id}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{ width: '17%', fontWeight: '600', color: 'var(--second-color)' }}>
                  {elemento.name}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{ color: 'var(--txt-color)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {elemento.description}
                </div>
                {/* Modern Color Swatch */}
                <div className="field-body-table-mantenimiento field-larger" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '8px',
                    backgroundColor: elemento.color,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }} />
                  <span style={{ fontFamily: 'monospace', color: 'var(--txt-color)', fontSize: '13px' }}>{elemento.color}</span>
                </div>
                {/* Icon 1: Primary Dark Background */}
                <div className="field-body-table-mantenimiento field-larger" style={{ justifyContent: 'center' }}>
                  {
                    (elemento.img == null) ? <span style={{ color: 'var(--second-color)', fontStyle: 'italic', fontSize: '12px' }}>N/A</span> :
                      <div style={{
                        width: '36px', height: '36px',
                        backgroundColor: '#003757',
                        borderRadius: '10px',
                        display: "flex", justifyContent: 'center', alignItems: 'center',
                        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3), 0 1px 2px rgba(255,255,255,0.1)'
                      }}>
                        <img src={'/iconos/' + elemento.img} alt="icon" style={{ width: '20px', height: '20px', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
                      </div>
                  }
                </div>
                {/* Icon 2: Dynamic Element Background */}
                <div className="field-body-table-mantenimiento field-larger" style={{ justifyContent: 'center' }}>
                  {
                    (elemento.img == null) ? <span style={{ color: 'var(--second-color)', fontStyle: 'italic', fontSize: '12px' }}>N/A</span> :
                      <div style={{
                        width: '36px', height: '36px',
                        backgroundColor: elemento.color,
                        borderRadius: '10px',
                        display: "flex", justifyContent: 'center', alignItems: 'center',
                        boxShadow: `0 3px 6px ${elemento.color}66`
                      }}>
                        <img src={'/iconos/' + elemento.img} alt="icon" style={{ width: '22px', height: '22px', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
                      </div>
                  }
                </div>
                {/* Tag Preview */}
                <div className="field-body-table-mantenimiento field-larger" style={{ justifyContent: 'center' }}>
                  <div style={{
                    padding: '6px 14px',
                    fontWeight: '600',
                    fontSize: '12px',
                    letterSpacing: '0.4px',
                    color: '#ffffff',
                    backgroundColor: elemento.color,
                    borderRadius: '20px',
                    display: "inline-flex",
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxShadow: `0 2px 5px ${elemento.color}80, inset 0 1px 1px rgba(255,255,255,0.3)`,
                    border: '1px solid rgba(0,0,0,0.1)'
                  }}>
                    {elemento.shortName}
                  </div>
                </div>
                {/* Extracted Action Buttons */}
                <div className="field-body-table-mantenimiento field-larger" style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
                  {/* <div 
                      onClick={() => handleChangEdit(elemento)}
                      style={{ cursor: 'pointer', padding: '6px', borderRadius: '8px', transition: 'background 0.2s', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,123,255,0.1)'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      title="Editar"
                    >
                      <img src="/iconos/editar.png" alt="Editar" style={{ width: '20px', height: '20px', opacity: 0.85 }} />
                    </div>
                    
                    <div 
                      onClick={() => handledeleteUserClick(elemento)}
                      style={{ cursor: 'pointer', padding: '6px', borderRadius: '8px', transition: 'background 0.2s', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,0,0,0.1)'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      title="Eliminar"
                    >
                      <img src="/iconos/delete.png" alt="Eliminar" style={{ width: '20px', height: '20px', opacity: 0.85 }} />
                    </div> */}
                </div>
              </div>
            ))
        )}
        {dataList.length == 0 ? (
          <div className="no-results">{lang[languaje]['sinResultados']}.</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalDeleteUSer languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteUSer>
      </Modal>
    </>
  );
};

export default PortafolioList;
